// extracted by mini-css-extract-plugin
module.exports = {"reviewComponentContainer":"Reviews__reviewComponentContainer___3Njgz","reviewsHeader":"Reviews__reviewsHeader___33A6W"};